import React from "react";
import HeaderLabelWithTooltip from "./HeaderLabelWithTooltip";

interface GroupedHeaderParentCellProps {
  label: string | React.ReactNode;
  labelTooltip?: string;
  colSpan: number;
  isFirstColumn?: boolean;
  isLastColumn?: boolean;
}

export default function GroupedHeaderParentCell({
  label,
  labelTooltip,
  colSpan,
  isFirstColumn = false,
  isLastColumn = false,
}: GroupedHeaderParentCellProps) {
  const horizontalPaddingClass =
    isFirstColumn && isLastColumn
      ? "px-4"
      : isFirstColumn
        ? "pl-4 pr-1"
        : isLastColumn
          ? "pl-1 pr-4"
          : "px-1";

  return (
    <th
      colSpan={colSpan}
      className={`table-grouped-header-parent bg-accent-Default-dark py-2 text-center text-sm font-medium text-white ${horizontalPaddingClass}`}
      scope="colgroup"
    >
      {typeof label === "string" ? (
        <HeaderLabelWithTooltip label={label} tooltip={labelTooltip} />
      ) : (
        label
      )}
    </th>
  );
}
